export const en = {
  pageTitle: "Gift Cards",
  searchPlaceholder: "Search gift cards",
  helpShop: "Browse gift cards and see available rewards.",
  helpMyCards: "View gift cards you have already purchased.",
  tabShop: "Shop",
  tabMyCards: "My Cards",
  loading: "Loading gift cards...",
  defaultBrand: "Gift Card",
  noArtwork: "No artwork",
  unavailableTitle: "Gift cards are unavailable",
  unavailableBody: "We could not load gift cards right now. Please try again later.",
  shopErrorTitle: "Could not load gift cards",
  shopErrorBody: "Refresh the page or try again in a moment.",
  catalogEmptyTitle: "No gift cards found",
  catalogEmptyBody: "Try a different search or country.",
  signInTitle: "Log in to view your gift cards",
  signInBody: "Your purchased gift cards are available after you log in.",
  signIn: "Log in",
  bagEmptyTitle: "No gift cards yet",
  bagEmptyBody: "Gift cards you purchase will appear here.",
  noMatches: "No matching gift cards",
  earnUpToPercentBack: "Earn up to {{value}}% back",
  earnUpToCashBack: "Earn up to {{amount}} back",
  continueToPurchase: "Continue to Purchase",
  selectAmount: "Select an amount",
  customAmount: "Custom amount",
  customAmountPlaceholder: "Enter amount",
  amountRangeHint: "Enter an amount between {{min}} and {{max}}",
  amountMinHint: "Enter at least {{min}}",
  amountMaxHint: "Enter up to {{max}}",
  amountInvalid: "Enter a valid amount",
  back: "Back",
  youPay: "You pay",
  youEarn: "You earn",
  paymentHeadlinePrefix: "You are paying {{amount}}",
  paymentHeadlineJoiner: "and",
  paymentHeadlineReward: "earning {{reward}}",
  paymentHeadlineRewardType: "in Cash ({{currency}})",
  paymentMethod: "Payment method",
  confirmPay: "Confirm & Pay {{amount}}",
  signInToPurchase: "Log in to purchase",
  processing: "Processing your purchase...",
  addNewCard: "Add a new card",
  card: "Card",
  cardEndingIn: "Ending in {{last4}}",
  cardExpires: "Exp {{month}}/{{year}}",
  cardDetails: "Card details",
  postalCode: "Postal code",
  postalCodePlaceholder: "A1A 1A1",
  saveCard: "Save card",
  savingCard: "Saving...",
  cancel: "Cancel",
  stripeUnavailable: "Card payments are not available right now.",
  cardSetupError: "We couldn't start card setup. Please try again.",
  cardError: "We couldn't save your card. Please check the details and try again.",
  methodsError: "We couldn't load your saved cards.",
  paymentError: "Your payment could not be completed. Please try again.",
  cardDeclined: "Your card was declined. Please try a different card.",
  insufficientFunds: "Your card has insufficient funds. Please try a different card.",
  purchaseComplete: "Purchase complete",
  purchaseCompleteBody: "Your {{amount}} gift card is ready in My Cards.",
  youPaid: "You paid",
  youEarned: "You earned",
  viewMyWallet: "View my Wallet",
  cardNumber: "Card number",
  pin: "PIN",
  barcodeAlt: "Gift card barcode",
  noImage: "No image available",
  amount: "Amount",
  purchasedFor: "Purchased for",
  balance: "Balance",
  description: "Description",
  howToUse: "How to use",
  terms: "Terms and Conditions",
  emptyDetails: "No additional details are available.",
  close: "Close",
};
